var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.mainTable.sarchCardShow
                ? _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("search-card", {
                            attrs: {
                              form: _vm.mainTable.searchForm,
                              "table-load-event": _vm.getAreaTableRecords,
                              "table-search": _vm.mainTable.tableSearch,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("区域管理")]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            size: "small",
                            shape: "circle",
                            type: "success",
                            icon: "ios-add-circle-outline",
                          },
                          on: { click: _vm.onAreaCreate },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.columns,
                      data: _vm.mainTable.data,
                      loading: _vm.mainTable.loading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getAreaTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Modal",
            {
              attrs: { title: "区域信息" },
              model: {
                value: _vm.areaFormShow,
                callback: function ($$v) {
                  _vm.areaFormShow = $$v
                },
                expression: "areaFormShow",
              },
            },
            [
              _c(
                "Form",
                { attrs: { "label-position": "top" } },
                [
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "区域名称" } },
                            [
                              _c("Input", {
                                model: {
                                  value: _vm.areaForm.areaName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.areaForm, "areaName", $$v)
                                  },
                                  expression: "areaForm.areaName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "区域代码" } },
                            [
                              _c("Input", {
                                model: {
                                  value: _vm.areaForm.areaCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.areaForm, "areaCode", $$v)
                                  },
                                  expression: "areaForm.areaCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "备注" } },
                            [
                              _c("Input", {
                                model: {
                                  value: _vm.areaForm.areaRemark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.areaForm, "areaRemark", $$v)
                                  },
                                  expression: "areaForm.areaRemark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "12" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "状态" } },
                            [
                              _c(
                                "RadioGroup",
                                {
                                  attrs: { type: "button" },
                                  model: {
                                    value: _vm.areaForm.areaStatus,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.areaForm, "areaStatus", $$v)
                                    },
                                    expression: "areaForm.areaStatus",
                                  },
                                },
                                _vm._l(_vm.approvalSource, function (item) {
                                  return _c(
                                    "Radio",
                                    {
                                      key: item.val,
                                      attrs: { label: item.val },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.label) +
                                          "\n\t\t\t\t\t        "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "Button",
                    {
                      staticClass: "form-button",
                      attrs: { type: "success" },
                      on: { click: _vm.onSave },
                    },
                    [_vm._v("保存")]
                  ),
                  _c(
                    "Button",
                    {
                      staticClass: "form-button",
                      attrs: { type: "text" },
                      on: { click: _vm.onCancel },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }